<template>
  <AccessHandler
    :requiredRoleGroups="roleGroups"
    @accessChanged="(a: boolean) => (hasAccess = a)"
  />
  <div class="schedule-a-page" data-cy="schedule-a-page">
    <MasterPage>
      <template v-if="!isMobile() && hasAccess" v-slot:content>
        <header class="page__header--container clearfix">
          <h1 class="page__title--text pull-left">
            INGREDIENT LISTING <small>Schedule A</small>
          </h1>
        </header>
        <div class="schedule-a-container">
          <ScheduleAView />
        </div>
        <GlobalFooter />
      </template>

      <template v-else-if="hasAccess" v-slot:content>
        <div class="sched-panel-title">
          <span class="schedule-title" data-cy="sched-a-mobile-page-title"
            >Ingredient Listing <small>Schedule A</small></span
          >
        </div>
        <ScheduleAMobileView />
        <GlobalFooter />
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import MasterPage from "../MasterPage.vue";
import { useMainStore } from "@/stores/useMainStore";
import GlobalFooter from "../GlobalFooter.vue";
import ScheduleAView from "./ScheduleAView.vue";
import ScheduleAMobileView from "./ScheduleAMobileView.vue";
import {
  ScheduleAppGroup,
  IngredientsAppGroup,
  type RoleGroup,
} from "@/shared/access/RoleGroups";
import { ref } from "vue";
import AccessHandler from "@/shared/access/AccessHandler.vue";
import { isMobile } from "../../shared/helpers/mobileHelper";

const main = useMainStore();

const roleGroups = [
  {
    roles: [...ScheduleAppGroup.roles, ...IngredientsAppGroup.roles],
  },
  {
    roles: [],
    validateRestrictionsAsync: async () => {
      return (        
        main.companySummary?.denials.every(
          (d) => !d.SchedA || d.SchedA.toUpperCase() !== "ALL"
        )
      );
    },
  },
] as RoleGroup[];

const hasAccess = ref<boolean>(false);
</script>

<style scoped lang="scss">
.schedule-a-container {
  margin: 10px 30px 30px;
  padding: 0;
  width: auto;
}

.sched-panel-title {
  padding: 5px 15px;
  display: flex;
  font-size: 11px;
  background: #222;

  .schedule-title {
    color: white;
    font-weight: bold;
    font-size: 12px;
  }
}
</style>
